module.exports = __webpack_public_path__ + "img/majorTroop.214ee517.png";